import { render, staticRenderFns } from "./modalRealizarPedido.vue?vue&type=template&id=a118e2b4&scoped=true"
import script from "./modalRealizarPedido.vue?vue&type=script&lang=js"
export * from "./modalRealizarPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a118e2b4",
  null
  
)

export default component.exports